<div class="mainBoardMainDiv">
    <app-header></app-header>
    <div class="mainBoardBody">
        <app-sidebar></app-sidebar>
        <div class="appDynamicScreen">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>